import css from '../../../utils/css';

export default css`
  :host,
  #root > div {
    --widget-background-color: #ffffff;
    --widget-text-color: #3d576c;
    --widget-accent-background-color: #f7f8f9;
    --widget-accent-text-color: #20242e;
    --widget-divider-color: #e5e5e5;
    --widget-cta-color: #20242e;
    --widget-cta-background-color: #102e47;
    --widget-cta-text-color: #20242e;
    --widget-cta-border-color: #0edd98;

    --widget-cta-primary-color: rgb(53, 88, 110);
    --widget-cta-primary-color-contrast: #ffffff;

    --widget-form-selected-background-color: #00e889;
    --widget-form-selected-border-color: #033954;
    --widget-child-background-color: #ffffff;
    --widget-child-text-color: #20242e;

    --widget-modal-background-color: #ffffff;
    --widget-modal-background-color-contrast: #20242e;

    --widget-modal-border-radius-custom: 4px;
    --widget-modal-buttons-border-radius-custom: 4px;

    --widget-cta-color-inverse: #20242e;

    --widget-brand-logo: url('data:image/svg+xml,<svg width="100" height="30" xmlns="http://www.w3.org/2000/svg"><rect width="100" height="30" fill="%230edd98" rx="2"/><text x="50" y="19" font-family="Nunito Sans, sans-serif" font-size="10" fill="%2320242e" text-anchor="middle">oddschecker</text></svg>');

    /* Button theming for oddschecker */
    --widget-button-border-radius: 3px;
    --widget-button-height: 40;
    --widget-button-background: #f2f5f6;
    --widget-button-background-hover: #66f1b8;
    --widget-button-selected-background: #00e889;
    --widget-button-selected-text: #ffffff;
    --widget-button-border: none;
  }
`;
